import React, { MouseEvent, useContext } from "react";
import styled from "styled-components";
import { Icon } from '@blueprint/ui';

import { DownloadMeta } from "../../api/attachment";
import { UploadedFile } from "../../types/common";
import { triggerFileDownload } from "../../utils/download";
import AttachmentContext from "../contexts/AttachmentContext";

type FileRowProps = {
    file: UploadedFile;
    canDownload?: boolean;
    downloadMeta?: DownloadMeta;
};

const FileRow = ({
    file,
    canDownload,
    downloadMeta,
}: FileRowProps): JSX.Element => {
    const { getDownloadPath } = useContext(AttachmentContext);
    const downloadPath = getDownloadPath(file.id, downloadMeta);

    const onDownloadClick = (event: MouseEvent<HTMLAnchorElement>): void => {
        event.preventDefault();
        triggerFileDownload(downloadPath);
    };

    return (
        <Container className="d-flex align-items-center bg-background-grey px-2">
            <Icon titleAccess={'Document'} margin="0" key={'Document'} name={'Document'} />
            <FileName className="flex-grow-1 mb-0 mx-2">
                {file.name}
            </FileName>
            {canDownload && (
                <a
                    href={downloadPath}
                    onClick={onDownloadClick}
                    style={{fontSize: '0'}}
                >
                    <Icon name={'Download'} title={`Download ${file.name}`}/>
                </a>
            )}
        </Container>
    );
};

const Container = styled.div`
    padding-top: 6px;
    padding-bottom: 6px;

    &:not(:last-child) {
        margin-bottom: 0.5rem;
    }
`;

const FileName = styled.span`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export default FileRow;
